<template>
    <div>
        <slot v-bind="self"/>
    </div>
</template>
<script>

import {reactive} from "vue";

const pdp_store = reactive({
    search: '',
    currentSort: 'DocumentNumber',
    sortDirection: 'desc'
});

export default {
    name: "PaginatedDocuments",
    data: {
        postURL: '',
        accessCode: '',
        loggedIn: false,
        documents: [],
        loaded: false,
        page: 1,
        perPage: 5,
        pages: [],
        search: '',
        documentColumns: [],
        currentSort: 'DocumentNumber',
        sortDirection: 'desc',
        loginModalOpen: false,
        loginModalError: '',
        style: null,
        key: null,
        class: null
    },

    created: function () {
        this.setupPageWithSettings();
    },

    methods: {
        // Get all documents for the page
        getDocuments: function () {
            fetch(this.postURL)
                .then(response => response.json()) // Convert the response to JSON
                .then(data => {
                    // Handle the data
                    this.documents = data;
                    this.loaded = true;
                })
                .catch(error => {
                    // Handle any errors
                    console.error('Error:', error);
                });
        },

        // get current page settings and documents
        setupPageWithSettings: function () {
            // retrieve page settings
            // NB: use POST to avoid response caching (IE I'm looking at you...)
            fetch(this.getURL() + 'getpagesettings', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // For form data; use 'application/json' for JSON data
                },
                body: new URLSearchParams({
                    // Your data here as key-value pairs if needed
                })
            })
                .then(response => response.json())
                .then(data => {
                    this.documentColumns = data['Columns'];
                    this.perPage = data['PerPage'];
                    this.postURL = data['PostURL'];
                    this.loggedIn = data['isAuth'];
                    this.getDocuments();
                })
                .catch(error => console.error('Error:', error));
        },

        // Get the current page documents
        getPaginatedList: function (documents) {
            var page = this.page;
            var perPage = this.safePerPage;
            var from = (page * perPage) - perPage;
            var to = (page * perPage);
            return documents.slice(from, to);
        },

        // Set pages array based on document list
        setPages: function (docList) {
            this.pages = [];
            var numberOfPages = Math.ceil(docList.length / this.safePerPage);
            for (var i = 1; i <= numberOfPages; i++) {
                this.pages.push(i);
            }
        },

        // Apply a class if the page being viewed is the current page
        pageIsActive: function (page) {
            if (page == this.page) {
                return true;
            }

            return false;
        },

        goToFirstPage: function () {
            this.page = 1;
        },

        sortedColumn: function (col) {
            if (col === this.currentSort) {
                return this.sortDirection;
            }
        },

        // Search Documents Function
        searchDocuments: function () {
            var docList = [];
            var documents = this.documents;
            for (var i = 0; i < documents.length; i++) {
                if (documents[i]['Title'].indexOf(this.search) != -1) {
                    docList.push(documents[i]);
                }
            }

            return docList;
        },

        // Set the sort parameters and trigger a view update
        sort: function (sortColumn) {
            if (this.currentSort === sortColumn) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = sortColumn;
                this.sortDirection = 'asc';
            }
        },

        submitAccessCode: function () {
            const url = `${this.getURL()}submitaccesscode?AccessCode=${encodeURIComponent(this.accessCode)}`;
            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    // Assuming the response data indicates a successful login
                    this.loggedIn = true;
                    this.loginModalOpen = false;
                    this.loginModalError = false;
                    document.getElementById('modal-container').classList.remove('show-modal');
                })
                .catch(error => {
                    this.loginModalError = true;
                    console.error('Error:', error);
                    document.getElementById('modal-error').classList.add('error');
                });
        },

        showModal: function () {
            document.getElementById('modal-container').classList .toggleClass('show-modal');
        },

        getURL: function () {
            var baseURL = window.location.origin;
            var path = window.location.pathname;
            if (path.substring(path.length - 1) != '/') {
                path += '/';
            }

            return baseURL + path;
        }

    },

    // Updates pages list once we have our documents loaded
    watch: {
        documents: function () {
            this.setPages(this.documents);
        },
        search:  function () {
            pdp_store.search = this.search;
        },
        currentSort: function () {
            pdp_store.currentSort = this.currentSort;
        },
        sortDirection: function () {
            pdp_store.sortDirection = this.sortDirection;
        }
    },

    // Compute which documents to display on the current page
    computed: {
        self() {
            return this;
        },

        displayedDocuments: function () {

            var localSearch = this.search.toLowerCase();
            var localDirection = this.sortDirection;
            var localCurrentSort = this.currentSort;

            var list = this.documents.filter(function (a)  {

                // only search with 3+ characters
                if ( !localSearch || localSearch.length < 3) {
                    return true;
                }

                // search against selected fields
                if (a.hasOwnProperty("DocumentNumber") && a.DocumentNumber && a.DocumentNumber.toLowerCase().indexOf(localSearch) !== -1) {
                    return true;
                }
                if (a.hasOwnProperty("Title") && a.Title && a.Title.toLowerCase().indexOf(localSearch) !== -1) {
                    return true;
                }
                if (a.hasOwnProperty("RelevantStandardID") && a.RelevantStandardID && a.RelevantStandardID.toLowerCase().indexOf(localSearch) !== -1) {
                    return true;
                }

                // search not found
                return false;
            }).sort(function (a, b) {
                var modifier = 1;
                var aUC = '';
                var bUC = '';

                // Convert everything to uppercase to give a better sorting result
                if (typeof a[localCurrentSort] !== "undefined" && a[localCurrentSort] !== null) {
                    aUC = a[localCurrentSort].toUpperCase();
                }

                if (typeof b[localCurrentSort] !== "undefined" && b[localCurrentSort] !== null) {
                    bUC = b[localCurrentSort].toUpperCase();
                }

                // Modifier to determine sort direction
                if (localDirection === 'desc') {
                    modifier = -1;
                }

                if (aUC < bUC) {
                    return -1 * modifier;
                }

                if (aUC > bUC) {
                    return 1 * modifier;
                }

                return 0;
            });

            this.setPages(list);
            return this.getPaginatedList(list);
        },

        safePerPage: function () {
            return (this.perPage > 0) ? this.perPage : 25;
        }
    }
}
</script>
